<template>
  <footer class="footer">
    <div class="footer-inner">
      <slot></slot>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  padding-top: 33px;
  border-top: 1px solid #F3F4F6;
}

.footer-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
